<!-- <button *ngIf="!isScrolled" class="open-nav d-none " (click)="openOffcanvasNavbar()">Menu<img src="assets/icons/list.svg" alt=""></button> -->
<nav class="navbar fixed-top nav" Id="nav">
  <div class="container-fluid">
    @if (logoScrolled()) {
      <a class="navbar-brand company_logo_nav mx-auto second-logo" href="" id="companyLogo">
        <img src="assets/imgs/zumera-logo-red.png" class="img-fluid nav-logo-image" alt="">
      </a>
    }
    <!--
    <a *ngIf="!logoScrolled" class="navbar-brand" href="" class="company_logo_nav mx-auto  first-logo" id="companyLogo">
      <img src="assets/icons/zumera_icon_white.png" class="img-fluid " alt="">
    </a> -->

    <button id="menuBtn" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" (click)="slideNavlinks()"  class="navbar-toggler bs-toggle" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasDarkNavbar" aria-controls="offcanvasDarkNavbar" aria-label="Toggle navigation">
      <span class="menu-text">MENU</span>
      @if (!logoScrolled()) {
        <img src="assets/icons/zumera_icon_white.png" width="30" height="30" class="img-fluid nav-toggle-icon" alt="">
      }
      @if (logoScrolled()) {
        <img src="assets/icons/z_icon_black.png" width="30" height="30" class="img-fluid nav-toggle-icon" alt="">
      }

    </button>


    <div class="offcanvas w-50  offcanvas-end " tabindex="-1" id="offcanvasDarkNavbar" aria-labelledby="offcanvasDarkNavbarLabel" #offcanvasNavbar>
      <div class="offcanvas-header justify-content-end ">
        <button type="button" class="btn-close btn-close-dark" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body overflow-hidden ">
        <ul class="navbar-nav justify-content-end flex-grow-1 ">
          <li class="nav-item dropdown" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              ZUMERA PROJECTS
            </a>
            <ul class="dropdown-menu dropdown-menu-dark">
              <li><a class="dropdown-item">RJ INTERNATIONAL</a></li>
              <li><a class="dropdown-item" routerLink="/projects/Elites-Residence" data-bs-dismiss="offcanvas" aria-label="Close">ELITES RESIDENCE</a></li>
              <li><a class="dropdown-item" routerLink="/projects/Queen-Idia" data-bs-dismiss="offcanvas" aria-label="Close">QUEEN IDIA RESIDENCE</a></li>
            </ul>
          </li>

          <li class="nav-item"(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/hospitality" routerLinkActive="active"  data-bs-dismiss="offcanvas" aria-label="Close">ZUMERA HOSPITALITY</a>
          </li>

          <li class="nav-item" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/what-we-do" data-bs-dismiss="offcanvas" aria-label="Close">ZUMERA EXPERTISE</a>
          </li>

          <li class="nav-item dropdown" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link dropdown-toggle" href="#" routerLinkActive="active" role="button" data-bs-toggle="dropdown" aria-expanded="false" >
              ABOUT ZUMERA
            </a>
            <ul class="dropdown-menu dropdown-menu-dark">
              <li><a class="dropdown-item" routerLink="/who-we-are/about-us" data-bs-dismiss="offcanvas" aria-label="Close">ABOUT US</a></li>
              <li><a class="dropdown-item" routerLink="/who-we-are/leadership" data-bs-dismiss="offcanvas" aria-label="Close">LEADERSHIP</a></li>
            </ul>
          </li>
          <li class="nav-item" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/who-we-are/csr" data-bs-dismiss="offcanvas" aria-label="Close">VALUE CREATION INITIATIVES</a>
          </li>

          <li class="nav-item"(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/join-our-tribe"  data-bs-dismiss="offcanvas" aria-label="Close">JOIN THE ZUMERA TRIBE</a>
          </li>
          <li class="nav-item"(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/news"  data-bs-dismiss="offcanvas" aria-label="Close">NEWS</a>
          </li>
          <li class="nav-item"(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
            <a class="nav-link" routerLink="/contact-us"  data-bs-dismiss="offcanvas" aria-label="Close">CONTACT</a>
          </li>

        </ul>
      </div>
    </div>
  </div>
</nav>
